import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { FieldConfigResponse, FieldPrefillResponse } from './document-fields.models';

@Injectable({
  providedIn: 'root'
})
export class FieldConfigService {
  private readonly _http = inject(HttpClient);

  /** The tenant-wide field mask. Takes no parameters: it is the same for every dossier. */
  public getFieldConfig(): Promise<FieldConfigResponse> {
    return firstValueFrom(
      this._http.get<FieldConfigResponse>('/api/office/Mailablage/FieldConfig')
    );
  }

  /**
   * Which mail part prefills which field of the mask, tenant-wide like the mask
   * itself. A tenant without the layout answers 200 with an empty body, which
   * comes out here as no prefill at all.
   */
  public async getFieldPrefill(): Promise<FieldPrefillResponse> {
    const response = await firstValueFrom(
      this._http.get<Partial<FieldPrefillResponse> | null>('/api/office/Mailablage/FieldPrefill')
    );

    return { felder: response?.felder ?? [] };
  }
}
